import type { LoadingEffect } from "@wa/core/theme";
import { AiThinkingOrb } from "@wa/ui";

/**
 * Loading backdrop (behind the card) for the "We're building your site" state - chosen via the
 * Customize → Start "loading effect" setting (`funnel.loading.effect`). Purely decorative,
 * `aria-hidden`. "orb" = shared AiThinkingOrb; "aurora"/"pulse" = shared CSS
 * (@wa/ui styles.css); "none" = empty. Default "orb".
 */
export function BuildingBackdrop({ effect = "orb" }: { effect?: LoadingEffect }) {
  switch (effect) {
    case "none":
      return null;
    case "aurora":
      return (
        <div className="funnel-aurora" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    case "pulse":
      return (
        <div className="funnel-pulse" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    case "orb":
    default:
      return <AiThinkingOrb />;
  }
}
